
const AUTHENTICITY_TOKEN_ERROR_MESSAGE = 'Sorry, your request could not be processed as it contained an invalid security token. Please refresh and try again.'
const MAX_FIFO_QUEUE_SIZE = 50

// Nifty trick: The XSRF headers get sent down in Set-Cookie no matter what
// So if we get a 403 with something telling us that we are forging, we
//   can use the fact that the XSRF-TOKEN gets updated by the 403 response.
export const XsrfResilient = asyncFunctor => async (...args) => {
  try {
    return await asyncFunctor(...args)
  } catch (possibleXsrfResponse) {
    const { response: { data: { error }={} }={} } = possibleXsrfResponse
    if (error === AUTHENTICITY_TOKEN_ERROR_MESSAGE) {
      return await asyncFunctor(...args)
    } else {
      throw error
    }
  }
}

export const StencilApiHeaders = (method='get', config={}, options={}, contentType='application/json') => ({
  'stencil-config': JSON.stringify(config),
  'stencil-options': JSON.stringify(options),
  ...(method === 'get'
    ? {}
    : {
      'content-type': contentType,
      'accept': '*/*'
      })
})

export const CustomFieldIdByLabel = ({ fields=[], label='' }) => {
  const field = fields &&
                fields.find &&
                fields.find(field => field.label === label)
  return (field || {}).id
}

export const IsShipToConsignment = ({ consignment, fieldId }) => {
  return (String(CustomFieldValueById({ ...consignment, fieldId })) !== '1')
}

export const CustomFieldValueById = ({ shippingAddress, fieldId }) => {
  const field = shippingAddress &&
                Array.isArray(shippingAddress.customFields) &&
                shippingAddress.customFields.find(field => field.fieldId === fieldId)
  return (field || {}).fieldValue
}

export const IsBopusStoreConsignment = ({ consignment, fieldId, storeId }) => {
  return CustomFieldValueById({ ...consignment, fieldId }) === storeId
}

export const Copy = object => JSON.parse(JSON.stringify(object))


const ClientSideGlobalFifoCacheStorage = {}
var ClientSideGlobalCacheSpaceIndex = 0
const FifoStorage = []

const AppendGlobalCache = ({ key, space, value }) => {
  ClientSideGlobalFifoCacheStorage[space] = ClientSideGlobalFifoCacheStorage[space] || {}
  ClientSideGlobalFifoCacheStorage[space][key] = value
  FifoStorage.push({ space, key })
  if (FifoStorage.length > MAX_FIFO_QUEUE_SIZE) {
    const removable = FifoStorage.shift()
    if (!(removable.space === space && removable.key === key)) {
      delete ClientSideGlobalFifoCacheStorage[removable.space][removable.key]
    }
  }
}

const GlobalCacheContains = ({ key, space }) => ClientSideGlobalFifoCacheStorage.hasOwnProperty(space) && ClientSideGlobalFifoCacheStorage[space].hasOwnProperty(key)
const GlobalCacheAccess = ({ key, space }) => ClientSideGlobalFifoCacheStorage[space][key]

export const ClientSideCache = computation => functor => {
  if (!process.browser) {
    return functor
  }
  const space = ClientSideGlobalCacheSpaceIndex++
  return async (...args) => {
    const key = computation(...args)
    const value = GlobalCacheContains({ space, key }) ? GlobalCacheAccess({ space, key }) : functor(...args)
    AppendGlobalCache({ space, key, value })
    return await GlobalCacheAccess({ key, space })
  }
}

// Helper to determine if all shipments have a valid option ID for a given order
export const areAllShipmentsAssigned = (order) => (
  order?.shipments.length
  && order.shipments.filter((i) => !!(i.selectedShippingOption)).length === order.shipments.length
)
